module.exports = __webpack_public_path__ + "static/media/tesoro.07ddac49.svg";